
import Default from '~/components/templates/default';
import page from '~/plugins/mixins/page';

export default {
  components: {
    Default,
  },
  mixins: [page],
  auth: false,
  computed: {
    template() {
      return Default;
    },
  },
};
